// *************************************
// NOTE: THIS REDUCER IS DEPRECATED
// ALL DIRTY TRACKING SHOULD NOW BE
// DONE USING REACT ROUTER
// *************************************

import types from 'actions/types'
import {combineReducers} from 'redux'
import Immutable from 'seamless-immutable'

const status = (state = Immutable(false), action) => {
  switch (action.type) {
    case types.DIRTY_SET_STATUS: return action.status
    case types.SET_DIRTY: return action.status
    default: return state
  }
}

const showPrompt = (state = Immutable(false), action) => {
  switch (action.type) {
    case types.DIRTY_SHOW_PROMPT: return true
    case types.DIRTY_HIDE_PROMPT: return false
    default: return state
  }
}

const saveAction = (state = Immutable({}), action) => {
  switch (action.type) {
    case types.DIRTY_SET_SAVE_ACTION: return action.saveAction
    default: return state
  }
}

const targetRoute = (state = Immutable(''), action) => {
  switch (action.type) {
    case types.DIRTY_SET_TARGET_ROUTE: return action.targetRoute
    default: return state
  }
}

const isFormValid = (state = Immutable(true), action) => {
  switch (action.type) {
    case types.DIRTY_SET_FORM_VALID: return action.isFormValid
    case types.DIRTY_FORM_IS_INVALID: return false
    default: return state
  }
}

export default combineReducers({
  status,
  showPrompt,
  saveAction,
  targetRoute,
  isFormValid,
})
